<template>
    <VueGoodTable
            v-if="ready"
            :columns="columnsWithState"
            :rows="rows"
            @on-row-click="onRowClick"
            :pagination-options="{
                setCurrentPage: query.page,
                perPage: query.limit,
                enabled: true
              }"
            :sort-options="{
                initialSortBy: querySort
              }"
            :isLoading="loading"
            :totalRows="total"
            :mode="mode"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            styleClass="vgt-table condensed"
            :row-style-class="rowClass"
            class="vgt-table--card"
    >
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
            <slot :name="name" v-bind="slotData" />
        </template>
    </VueGoodTable>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import { dotNotationToNested, getUsingDotNotation } from '../../utils/helpers';

export default {
  props: {
    columns: {},
    rows: {},
    query: {},
    total: {},
    loading: {},
    rowClass: {},
    mode: { default: 'remote' },
  },
  components: {
    VueGoodTable,
  },
  data() {
    return {
      ready: true,
    };
  },
  computed: {
    querySort() {
      return JSON.parse(JSON.stringify(this.query.sort));
    },
    columnsWithState() {
      return this.columns.map((column) => {
        if (column.hasOwnProperty('filterOptions')
          && column.filterOptions.hasOwnProperty('enabled')
          && column.filterOptions.enabled
        ) {
          column.filterOptions.filterValue = getUsingDotNotation(this.query.filters, column.field);
        }
        return column;
      });
    },
  },
  mounted() {
    // this.reset();
  },
  methods: {
    reset() {
      this.ready = false;
      this.$nextTick(() => {
        this.ready = true;
      });
    },
    onRowClick(event) {
      this.$emit('on-row-click', event);
    },
    onQueryChange(props) {
      this.$emit('on-query-change', props);
    },

    onPageChange(params) {
      this.onQueryChange({ page: params.currentPage });
    },

    onPerPageChange(params) {
      this.onQueryChange({ limit: params.currentPerPage, page: 1 });
    },

    onSortChange(params) {
      this.onQueryChange({ sort: params, page: 1 });
    },

    onColumnFilter(params) {
      const filters = dotNotationToNested(params.columnFilters);
      if (JSON.stringify(filters) === JSON.stringify(this.query.filters)) {
        // Hackfix. For some reason vue-good-table triggers this twice when initialSortBy is set
        return;
      }

      this.onQueryChange({ filters, page: 1 });
    },
  },
};
</script>
